var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleyellow74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 124,
    viewBox: "0 0 135 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 125L135 125L135 80C135 35.8172 99.1828 -6.58796e-06 55 -1.04505e-05L1.09278e-05 -1.52588e-05L0 125Z",
    fill: "#F4A807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleyellow74);
export default __webpack_public_path__ + "static/media/Rectangleyellow74.6119ff0d8d919f685ca2c6e77771cd1d.svg";
export { ForwardRef as ReactComponent };